import { render } from "./TermsModal.vue?vue&type=template&id=71f8e63e&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"

import "./TermsModal.vue?vue&type=style&index=0&id=71f8e63e&scoped=true&lang=scss"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f8e63e"]])

export default __exports__